import React, { useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import thankyouGif from "../../assets/game/thankyou.gif";
import mainDesktopBg from "../../assets/game/main-desktop.png";
import mainMobileBg from "../../assets/game/main-mobile.png";
import "./UnhealthyThankYouPage.css";

const APP_EXIT_MESSAGE = "navigate_back";
const FROM_MOBILE_APP_STORAGE_KEY = "lcp_fromMobileApp";

function appBaseUrl() {
  const base = (process.env.REACT_APP_BASE_URL || "").trim().replace(/\/+$/, "");
  return base || "/";
}

function formatMmSs(sec) {
  const total = Math.max(0, Number(sec) || 0);
  const mm = Math.floor(total / 60);
  const ss = total % 60;
  return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export default function UnhealthyThankYouPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const armedBackRedirectRef = useRef(false);
  const score = Number(location.state?.score) || 0;
  const elapsedSeconds = Number(location.state?.elapsedSeconds) || 0;
  const timeLabel = formatMmSs(elapsedSeconds);
  const fromMobileAppInUrl = searchParams.get("fromMobileApp") === "true";
  const isFromMobileApp = fromMobileAppInUrl;

  useEffect(() => {
    if (!isFromMobileApp) return undefined;
    const timerId = window.setTimeout(() => {
      window.GameStatus?.postMessage?.(APP_EXIT_MESSAGE);
    }, 5000);
    return () => window.clearTimeout(timerId);
  }, [isFromMobileApp]);

  useEffect(() => {
    const onPopState = () => {
      if (!armedBackRedirectRef.current) return;
      window.location.replace(appBaseUrl());
    };
    window.history.replaceState({ thankyou: true }, "", window.location.href);
    window.history.pushState({ thankyouGuard: true }, "", window.location.href);
    const armTimerId = window.setTimeout(() => {
      armedBackRedirectRef.current = true;
    }, 250);
    window.addEventListener("popstate", onPopState);
    return () => {
      window.clearTimeout(armTimerId);
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  useEffect(() => {
    const body = document.body;
    const prev = {
      backgroundImage: body.style.backgroundImage,
      backgroundSize: body.style.backgroundSize,
      backgroundPosition: body.style.backgroundPosition,
      backgroundRepeat: body.style.backgroundRepeat,
      backgroundAttachment: body.style.backgroundAttachment,
      minHeight: body.style.minHeight,
    };
    const apply = () => {
      const isMobile = window.innerWidth <= 768;
      const bg = isMobile ? mainMobileBg : mainDesktopBg;
      body.style.backgroundImage = `url("${bg}")`;
      body.style.backgroundSize = "cover";
      body.style.backgroundPosition = "center";
      body.style.backgroundRepeat = "no-repeat";
      body.style.backgroundAttachment = isMobile ? "scroll" : "fixed";
      body.style.minHeight = "100vh";
    };
    apply();
    window.addEventListener("resize", apply);
    return () => {
      window.removeEventListener("resize", apply);
      body.style.backgroundImage = prev.backgroundImage;
      body.style.backgroundSize = prev.backgroundSize;
      body.style.backgroundPosition = prev.backgroundPosition;
      body.style.backgroundRepeat = prev.backgroundRepeat;
      body.style.backgroundAttachment = prev.backgroundAttachment;
      body.style.minHeight = prev.minHeight;
    };
  }, []);

  return (
    <main className="unhealthy-thankyou">
      <div className="unhealthy-thankyou__overlay">
        <img src={thankyouGif} alt="Thank you" className="unhealthy-thankyou__gif" />
        <p>
          Your score is <strong>{score}</strong> in <strong>{timeLabel}</strong> mins.
        </p>
        {/* <button type="button" className="stage-submit" onClick={() => navigate("/leaderboard", { replace: true })}>
          Continue
        </button> */}
      </div>
    </main>
  );
}
